type SnapPointsArgs = {
  maxHeight: number
  minHeight?: number
}

type DefaultSnapArgs = {
  snapPoints: number[]
  lastSnap?: number
}

export const resolveBottomSheetHeight = (maxHeight: number): number => {
  if (maxHeight > 0) return maxHeight
  if (typeof window !== 'undefined') return window.innerHeight
  return 640
}

export const bottomSheetSnapPoints = ({ maxHeight }: SnapPointsArgs): number[] => {
  const height = resolveBottomSheetHeight(maxHeight)
  return [Math.round(height - height / 5), Math.round(height * 0.85)]
}

export const bottomSheetDefaultSnap = ({
  snapPoints,
  lastSnap
}: DefaultSnapArgs): number => {
  if (lastSnap != null && snapPoints.includes(lastSnap)) return lastSnap
  return snapPoints[0] ?? 0
}

export const bottomSheetMotionProps = {
  blocking: false,
  skipInitialTransition: true,
  defaultSnap: bottomSheetDefaultSnap,
  snapPoints: bottomSheetSnapPoints
} as const
